import { useFormikContext } from 'formik'

import { ImageInput } from 'src/components/form-title'
import { IAccountFormUpdate, ICustomIconFile, ISetStockImage } from 'src/types'
import { useRemoveAccountIcon } from 'src/hooks'
import { imageChangeHandler } from 'src/common/handlers'

export const AccountImageInput = () => {
  const { values, errors, setFieldValue } = useFormikContext<IAccountFormUpdate>()
  const { mutateAsync: removeIcon } = useRemoveAccountIcon()

  const handleIconRemove = () => {
    setFieldValue('image_small', null)
    setFieldValue('image_medium', null)
    setFieldValue('image', { icon: '', file: null })
    if (values.image?.file) return

    return removeIcon()
  }

  const handleImageChange = imageChangeHandler((data: ICustomIconFile) =>
    setFieldValue('image', data),
  )

  const handleStockImageSet: ISetStockImage = (img) => {
    setFieldValue('image', { icon: img, file: null })
    setFieldValue('image_small', null)
    setFieldValue('image_medium', null)
  }

  return (
    <ImageInput
      handleStockImageSet={handleStockImageSet}
      alt={values.account_holder}
      errorText={errors.image?.icon}
      handleImageChange={handleImageChange}
      image={values.image.file ? values.image.icon : values.image_medium || values.image.icon}
      originalImage={values.image.icon}
      isRound
      deleteImage={handleIconRemove}
    />
  )
}
